module.exports = __webpack_public_path__ + "fonts/avenir/3511a780-31ca-4ee1-9083-89b1b7185748.eot";


//////////////////
// WEBPACK FOOTER
// ./fonts/avenir/3511a780-31ca-4ee1-9083-89b1b7185748.eot
// module id = 3
// module chunks = 0